import { css } from 'styled-components';
import { themes } from 'seal-ui-components';

const { sizes, fonts } = themes.baseTheme.texts;

export default css`
    color: #000;
    position: absolute;
    left: 0;
    bottom: 15vh;
    right: 0;

    h1 {
        margin: 0 0 3.8rem 0;
    }

    p {
        margin: 0;
        padding: 0 3rem;
        font-size: ${sizes.l.fontSize};
        letter-spacing: ${sizes.s.letterSpacing};
        line-height: ${sizes.l.lineHeight};
        font-family: ${fonts.globalHeader.family};
        font-weight: ${fonts.globalHeader.fontWeights.semibold};
    }
`;
